import axios from '@/plugins/axios'

export default {
  fetch(params) {
    return axios.get('players', { params }).then(result => result.data)
  },
  get(id) {
    return axios.get(`players/${id}`).then(result => result.data)
  },
  update(id, data) {
    return axios.patch(`players/${id}`, data).then(result => result.data)
  },
  sync(playerIds) {
    return axios.post('players/sync', {
      player_ids: playerIds
    }).then(result => result.data)
  },
  reboot(playerIds) {
    return axios.post('players/reboot', {
      player_ids: playerIds
    }).then(result => result.data)
  },
  flash(data) {
    return axios.post('players/flash', data).then(result => result.data)
  },
  runDiagnostics(playerIds) {
    return axios.post('players/run-diagnostics', {
      player_ids: playerIds
    }).then(result => result.data)
  },
  assignToRadio(playerIds, radioId, sync = false) {
    return axios.post('players/assign-to-radio', {
      player_ids: playerIds,
      radio_id: radioId,
      sync: sync
    }).then(result => result.data)
  },
  delete(playerIds) {
    return axios.post('players/delete', {
      player_ids: playerIds
    }).then(result => result.data)
  },
  startSshSession(playerId) {
    return axios.post(`players/${playerId}/start-ssh`).then(result => result.data)
  },
  fetchLogs(playerId, params) {
    return axios.get(`players/${playerId}/logs`, { params }).then(result => result.data)
  },
  fetchNotes(playerId) {
    return axios.get(`players/${playerId}/notes`).then(result => result.data)
  },
  createNote(playerId, data) {
    return axios.post(`players/${playerId}/notes`, data).then(result => result.data)
  },
  updateNote(playerId, noteId, data) {
    return axios.patch(`players/${playerId}/notes/${noteId}`, data).then(result => result.data)
  },
  deleteNote(playerId, noteId) {
    return axios.delete(`players/${playerId}/notes/${noteId}`).then(result => result.data)
  },
  create(data) {
    return axios.post('players', data).then(result => result.data)
  }
}
